// NOTE: remember to update the UI-texts file on the drive, if you update this file */

const playerUiTexts = {
	/* Choose language */
	chooseLanguage: {
		da: 'Vælg sprog',
		en: 'Choose language',
	},

	/* Module overview */
	reset: {
		da: 'Reset',
		en: 'Reset',
	},

	moduleOverview: {
		da: 'Moduloversigt',
		en: 'Module overview',
	},
	employeeNumber: {
		da: 'Medarbejder-nr.',
		en: 'Employee no.',
	},

	/* Module - general */
	continue: {
		da: 'Videre',
		en: 'Next',
	},
	ok: {
		da: 'OK',
		en: 'OK',
	},
	choose: {
		da: 'Vælg',
		en: 'Choose',
	},
	option: {
		da: 'svar',
		en: 'option',
	},
	options: {
		da: 'svar',
		en: 'options',
	},
	finishBtn: {
		da: 'Afslut',
		en: 'Finish',
	},
	tryAgain: {
		da: 'Prøv igen',
		en: 'Try again'
	},



	/* Module - results */
	results: {
		da: 'resultat',
		en: 'results',
	},
	stars: {
		da: 'Stjerner',
		en: 'Stars',
	},
	points: {
		da: 'Point',
		en: 'Points',
	},
	timeSpent: {
		da: 'Tid brugt',
		en: 'Time spent',
	},
	avgErrors: {
		da: 'Antal fejl per opgave (gennemsnit)',
		en: 'Average mistakes per task',
	},
	noErrorsTasks: {
		da: 'Antal opgaver løst uden fejl',
		en: 'Number of tasks solved without mistakes',
	},
	backToModuleOverview: {
		da: 'Tilbage til moduloversigt',
		en: 'Back to module overview',
	},
	tryAgain: {
		da: 'Prøv igen',
		en: 'Try again',
	},
	confirmTryAgainPopup: {
		title: {
			da: 'Prøv igen',
			en: 'Try again'	,
		},
		text: {
			da: 'Vil du prøve at slå din egen score? Du kan nulstille modulet og spille igen.',
			en: 'Want to try to beat your own score? You can reset the module and play again.',
		},
		resetBtn: {
			da: 'Nulstil',
			en: 'Reset',
		},
		cancelBtn: {
			da: 'Afbryd',
			en: 'Cancel',
		}
	},

	/* Module - order task */
	orderPopup: {
		title: {
			da: 'Du fik %correctAnswers%/%totalAnswers%.',
			en: `You got %correctAnswers%/%totalAnswers%.`,
		},
		text: {
			da: 'Prøv igen!',
			en: `Try again!`,
		}
	},

	/* Module - spot errors task */
	spotErrorsPopup: {
		title1: {
			da: 'Ups!',
			en: 'Oops!',
		},
		text1: {
			da: 'Du fandt kun %spottedErrors% ud af %numberOfErrors% fejl.',
			en: 'You only %spottedErrors% of %numberOfErrors% errors.',
		},
		title2: {
			da: 'Ikke dårligt!',
			en: 'Not bad!',
		},
		text2: {
			da: 'Du fandt %spottedErrors% ud af %numberOfErrors% fejl.',
			en: 'You spotted %spottedErrors% of %numberOfErrors% errors.',
		},
		title3: {
			da: 'Godt klaret!',
			en: 'Well done!',
		},
		text3: {
			da: 'Du fandt %spottedErrors% ud af %numberOfErrors% fejl.',
			en: 'You spotted %spottedErrors% of %numberOfErrors% errors.',
		},
	}
};

module.exports = {
	playerUiTexts
};